import { render, staticRenderFns } from "./CardColl.vue?vue&type=template&id=0acd5ac3&scoped=true&"
import script from "./CardColl.vue?vue&type=script&lang=js&"
export * from "./CardColl.vue?vue&type=script&lang=js&"
import style0 from "./CardColl.vue?vue&type=style&index=0&id=0acd5ac3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acd5ac3",
  null
  
)

export default component.exports